import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    user: any;
    constructor(
        private cryptoJsService: CryptoJsService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
       // const user = this.accountService.retriveToken();

        // const token = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
        const token = sessionStorage.getItem('token') && sessionStorage.getItem('token') != 'undefined'
        ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
        : null;
        // let token = farmerConfData.get('token') ? farmerConfData.get('token') : '';

        const auth_token = token?.authToken

        // const token = sessionStorage.getItem('auth_token');
        
        if(request.url.includes('GetToken')){
        //   sessionStorage.clear();
          return next.handle(request);
        }else if (auth_token) {

            if(request.url.includes('File/Upload')){
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${auth_token}`,
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            else if(request.url.includes('https://api.ipify.org/?format=json')){
                request = request.clone({
                    setHeaders: {
                        // Authorization: `Bearer ${auth_token}`,
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            else{
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${auth_token}`,
                        'Content-Type':  'application/json',
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            return next.handle(request);
        }


    }
}
